/**
 * DRF returns {field: [messages]} with a 400 for validation errors; flatten
 * that into a form-level message plus per-field messages.
 * @returns {{general: string|null, fields: Record<string, string>}}
 */
export const parseApiError = (error, fallback = "Não foi possível salvar. Tente novamente.") => {
    const data = error.response?.data;
    if (error.response?.status !== 400 || !data || typeof data !== "object") {
        return {general: fallback, fields: {}};
    }
    const {non_field_errors: general, ...fields} = data;
    return {
        general: general ? [].concat(general).join(" ") : null,
        fields: Object.fromEntries(Object.entries(fields).map(([k, v]) => [k, [].concat(v).join(" ")])),
    };
};
